module.exports = __webpack_public_path__ + "media/video1-m.c751ae14.mp4";